module.exports = __webpack_public_path__ + "static/media/SPRAY6.91a8d6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY6.png
// module id = 288
// module chunks = 0